import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';

import { GetOrganizationDocument } from '../graphql/queries/__generated__/GetOrganization';
import { GetSessionDataDocument } from '../graphql/queries/__generated__/GetSessionData';

export const apolloClient = new ApolloClient({
  defaultOptions: {
    watchQuery: {
      notifyOnNetworkStatusChange: false,
    },
  },
  clientAwareness: { name: 'partnership-dashboard-fe', version: '1.0' },
  link: new HttpLink({
    uri: '/api/internal/graphql',
    credentials: 'include',
  }),
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          partnership: {
            merge: true,
          },
        },
      },
    },
  }),
});

// Local development hack to bypass authentication
// Enable by setting VITE_USE_MOCK_AUTH=true in .env.development.local
if (import.meta.env.DEV && import.meta.env.VITE_USE_MOCK_AUTH === 'true') {
  console.log('[Apollo] Using mock authentication data for local development');

  apolloClient.writeQuery({
    query: GetOrganizationDocument,
    data: {
      organization: {
        identifier: 'test_partner_ore',
        slug: 'test_partner_ore',
        partnershipType: 'ONLINE_REAL_ESTATE',
        __typename: 'Organization',
      },
    },
  });

  apolloClient.writeQuery({
    query: GetSessionDataDocument,
    data: {
      session: {
        human: {
          email: 'portlando3@gmail.com',
          first_name: 'Portlando3',
          full_name: 'Portlando3 Agento3',
          has_resale_closing_dashboard: true,
          has_partnership_referral_dashboard: true,
          has_partnership_developer_dashboard: true,
          impersonated: false,
          __typename: 'SessionHuman',
          id: 3,
        },
        logged_in: true,
        __typename: 'Session',
      },
    },
  });
}
